import { IconButton } from '@mui/material';

const ArrowBtnLft = ({ onClick, children, onMouseEnter, onMouseLeave, height, width, padding, id = '' }: any) => {
  return (
    <IconButton
      sx={{
        display: 'flex',
        padding: padding ? padding : '16px',
        background: 'var(--gray-0-transparent, #FFF)',
        height: height ? height : '56px',
        width: width ? width : '56px',
        borderRadius: '4px',
        border: '1px solid var(--gray-300, #E6E6E6)',
        ':hover': {
          background: 'var(--primary-600, #175CE5)',
          color: '#fff'
        }
      }}
      children={children}
      onClick={onClick}
      onMouseLeave={onMouseLeave}
      onMouseEnter={onMouseEnter}
      data-testid={id}
      className='left-arrow-btn'
    />
  );
};

export default ArrowBtnLft;
